var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Shadow",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E7F9F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 22.8C16 20.149 18.149 18 20.8 18H43.2C45.851 18 48 20.149 48 22.8V42C48 44.651 45.851 46.8 43.2 46.8H20.8C18.149 46.8 16 44.651 16 42V22.8ZM20.8 21.2C19.9164 21.2 19.2 21.9164 19.2 22.8V24.4H44.8V22.8C44.8 21.9164 44.0837 21.2 43.2 21.2H20.8ZM19.2 42V27.6H44.8V42C44.8 42.8837 44.0837 43.6 43.2 43.6H20.8C19.9164 43.6 19.2 42.8837 19.2 42ZM25.1314 31.2686C24.5065 30.6438 23.4935 30.6438 22.8686 31.2686C22.2438 31.8934 22.2438 32.9066 22.8686 33.5314L24.9373 35.6L22.8686 37.6686C22.2438 38.2934 22.2438 39.3066 22.8686 39.9314C23.4935 40.5562 24.5065 40.5562 25.1314 39.9314L28.3314 36.7314C28.9562 36.1066 28.9562 35.0934 28.3314 34.4686L25.1314 31.2686Z",
    fill: "#05BC86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticIcon5);
export default __webpack_public_path__ + "static/media/StatisticIcon_5.99c37f3eacf3f8a13931b97c4b0d747d.svg";
export { ForwardRef as ReactComponent };